import { sendGet, sendPost, sendPut, type Response } from '../../hooks/use-fetch'
import {
  type CollectionIndex,
  type CollectionFormView,
  type CollectionSubmissionSummary,
  type SaveP2PFormRequest,
  type SaveP2PFormResult,
  type SetProgramStatusRequest,
  type SubmitReportRequest,
  type SubmitReportResult,
  type MyDistrictsView,
  type UpdateMyDistrictsRequest,
  type P2PReportingYear
} from '../../models/peerToPeer/Collection'

export async function GetP2PIndex (): Promise<Response<CollectionIndex>> {
  return await sendGet('PeerToPeer/Index')
}

export async function GetP2PForm (organizationBuildingId: number, reportingYearId: number): Promise<Response<CollectionFormView>> {
  return await sendGet(`PeerToPeer/Form?organizationBuildingId=${organizationBuildingId}&reportingYearId=${reportingYearId}`)
}

export async function SaveP2PForm (request: SaveP2PFormRequest): Promise<Response<SaveP2PFormResult>> {
  return await sendPost('PeerToPeer/Form/Save', request)
}

export async function SetP2PProgramStatus (request: SetProgramStatusRequest): Promise<Response<unknown>> {
  return await sendPost('PeerToPeer/Form/ProgramStatus', request)
}

export async function SubmitP2PReport (request: SubmitReportRequest): Promise<Response<SubmitReportResult>> {
  return await sendPost('PeerToPeer/Report/Submit', request)
}

export async function GetP2PSummary (organizationBuildingId: number, reportingYearId: number): Promise<Response<CollectionSubmissionSummary>> {
  return await sendGet(`PeerToPeer/Form/Summary?organizationBuildingId=${organizationBuildingId}&reportingYearId=${reportingYearId}`)
}

export async function GetActiveReportingYear (): Promise<Response<P2PReportingYear | null>> {
  return await sendGet('PeerToPeer/ActiveYear')
}

export async function GetMyDistricts (reportingYearId: number): Promise<Response<MyDistrictsView>> {
  return await sendGet(`PeerToPeer/MyDistricts?reportingYearId=${reportingYearId}`)
}

export async function UpdateMyDistricts (request: UpdateMyDistrictsRequest): Promise<Response<unknown>> {
  return await sendPut('PeerToPeer/MyDistricts', request)
}
